import { render } from "./Contact.vue?vue&type=template&id=e7707762&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=e7707762&scoped=true&lang=scss"

import exportComponent from "/Users/spineup/Downloads/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7707762"]])

export default __exports__